module.exports = __webpack_public_path__ + "media/bootstrap-icons/handbag-fill-2e123e8e.svg";